(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealSections = document.querySelectorAll('.reveal-section');
  if ('IntersectionObserver' in window && revealSections.length > 0) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealSections.forEach(section => observer.observe(section));
  } else {
    revealSections.forEach(section => section.classList.add('is-visible'));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Vorteile"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealSections = document.querySelectorAll('.reveal-section');
  if ('IntersectionObserver' in window && revealSections.length > 0) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealSections.forEach(section => observer.observe(section));
  } else {
    revealSections.forEach(section => section.classList.add('is-visible'));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eyebrow"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function() {
  const revealSections = document.querySelectorAll('.reveal-section');
  if ('IntersectionObserver' in window && revealSections.length > 0) {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    revealSections.forEach(section => observer.observe(section));
  } else {
    revealSections.forEach(section => section.classList.add('is-visible'));
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landingpage"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function (event) {
  const button = event.target.closest('.hero-lead-cta__button');
  if (!button) return;

  const target = document.querySelector(
    '#shopify-section-template--27421910892873__form_U3WJi3'
  );

  if (!target) return;

  event.preventDefault();

  const start = window.scrollY;
  const offset = 110;
  const destination =
    target.getBoundingClientRect().top + window.scrollY - offset;

  const distance = destination - start;
  const duration = 700;
  let startTime;

  function easeInOutCubic(progress) {
    return progress < 0.5
      ? 4 * progress * progress * progress
      : 1 - Math.pow(-2 * progress + 2, 3) / 2;
  }

  function animateScroll(timestamp) {
    if (!startTime) startTime = timestamp;

    const progress = Math.min((timestamp - startTime) / duration, 1);
    window.scrollTo(0, start + distance * easeInOutCubic(progress));

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  }

  requestAnimationFrame(animateScroll);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
